module.exports = __webpack_public_path__ + "static/media/requisitosIMG_06.64588b72.svg";